import { PackageProviderName } from 'data/ppoints/constants';
import { transformToCdnUrl } from 'utils/google-storage-util';
import base from './tile-art.module.css';
import { ProviderLogoBadge } from './ProviderLogoBadge';
import styles from './LabelGeneratingTileArt.module.css';

export interface LabelGeneratingTileArtProps {
    provider?: PackageProviderName;
}

export const LabelGeneratingTileArt: React.FC<LabelGeneratingTileArtProps> = ({ provider }) => (
    <>
        <img
            className={`${base.layer} ${styles.box}`}
            src={transformToCdnUrl('embedded-assets/tiles/label-generating-tile-2.webp')}
            width={1080}
            height={1026}
            alt=""
            aria-hidden="true"
            loading="lazy"
        />
        <img
            className={`${base.layer} ${styles.label}`}
            src={transformToCdnUrl('embedded-assets/tiles/label-generating-tile-1.webp')}
            width={1153}
            height={628}
            alt=""
            aria-hidden="true"
            loading="lazy"
        />
        {!!provider && <ProviderLogoBadge provider={provider} className={styles.logoBadge} />}
    </>
);
